import { useEffect, useRef } from 'react';

export const PORTAL_IDLE_LOGOUT_MS = 30 * 60 * 1000;

const IDLE_CHECK_INTERVAL_MS = 60 * 1000;

const ACTIVITY_EVENTS = ['pointerdown', 'pointermove', 'keydown', 'scroll', 'touchstart', 'wheel'] as const;

export const useIdleLogout = (onIdle: () => void, idleMs: number = PORTAL_IDLE_LOGOUT_MS) => {
  const onIdleRef = useRef(onIdle);

  useEffect(() => {
    onIdleRef.current = onIdle;
  }, [onIdle]);

  useEffect(() => {
    let lastActivityAt = Date.now();
    let idleFired = false;

    const recordActivity = () => {
      lastActivityAt = Date.now();
    };

    const checkIdle = () => {
      if (idleFired || Date.now() - lastActivityAt < idleMs) return;
      idleFired = true;
      onIdleRef.current();
    };

    // Interval timers are throttled in background tabs, so also check when the
    // tab becomes visible again to log out immediately instead of up to a
    // check-interval later.
    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') checkIdle();
    };

    const intervalId = window.setInterval(checkIdle, IDLE_CHECK_INTERVAL_MS);
    ACTIVITY_EVENTS.forEach((event) => window.addEventListener(event, recordActivity, { passive: true }));
    document.addEventListener('visibilitychange', onVisibilityChange);

    return () => {
      window.clearInterval(intervalId);
      ACTIVITY_EVENTS.forEach((event) => window.removeEventListener(event, recordActivity));
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, [idleMs]);
};
